// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2F4mB","search":"Settings_search__1T_hf","filter":"Settings_filter__nQJ1B"};